var _circle, _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipseSoso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.175,
    cy: 5.62505,
    r: 4.6,
    transform: "rotate(-90 5.175 5.62505)",
    stroke: "#657787",
    strokeWidth: 1.15
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_805_1146",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.175 0.450048C3.8025 0.450048 2.48622 0.99527 1.51572 1.96577C0.545221 2.93627 -1.8258e-07 4.25255 -2.26206e-07 5.62505C-2.69833e-07 6.99754 0.545221 8.31383 1.51572 9.28433C2.48622 10.2548 3.8025 10.8 5.175 10.8L5.175 5.62505L5.175 0.450048Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.175 0.450048C3.8025 0.450048 2.48622 0.99527 1.51572 1.96577C0.545221 2.93627 -1.8258e-07 4.25255 -2.26206e-07 5.62505C-2.69833e-07 6.99754 0.545221 8.31383 1.51572 9.28433C2.48622 10.2548 3.8025 10.8 5.175 10.8L5.175 5.62505L5.175 0.450048Z",
    fill: "#657787",
    stroke: "#657787",
    strokeWidth: 2.3,
    mask: "url(#path-2-inside-1_805_1146)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseSoso);
export default __webpack_public_path__ + "static/media/ellipse-soso.9fd42ea03be07dff0146c01e2f2e548d.svg";
export { ForwardRef as ReactComponent };